import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./ui/button";
import { Slider } from "./ui/slider";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { X, SlidersHorizontal, MapPin } from "lucide-react";
import { tx } from "../lib/tx";

// French departments list
const DEPARTMENTS = [
  { code: "", name: "Tous les départements" },
  { code: "01", name: "01 - Ain" },
  { code: "02", name: "02 - Aisne" },
  { code: "03", name: "03 - Allier" },
  { code: "04", name: "04 - Alpes-de-Haute-Provence" },
  { code: "05", name: "05 - Hautes-Alpes" },
  { code: "06", name: "06 - Alpes-Maritimes" },
  { code: "07", name: "07 - Ardèche" },
  { code: "08", name: "08 - Ardennes" },
  { code: "09", name: "09 - Ariège" },
  { code: "10", name: "10 - Aube" },
  { code: "11", name: "11 - Aude" },
  { code: "12", name: "12 - Aveyron" },
  { code: "13", name: "13 - Bouches-du-Rhône" },
  { code: "14", name: "14 - Calvados" },
  { code: "15", name: "15 - Cantal" },
  { code: "16", name: "16 - Charente" },
  { code: "17", name: "17 - Charente-Maritime" },
  { code: "18", name: "18 - Cher" },
  { code: "19", name: "19 - Corrèze" },
  { code: "21", name: "21 - Côte-d'Or" },
  { code: "22", name: "22 - Côtes-d'Armor" },
  { code: "23", name: "23 - Creuse" },
  { code: "24", name: "24 - Dordogne" },
  { code: "25", name: "25 - Doubs" },
  { code: "26", name: "26 - Drôme" },
  { code: "27", name: "27 - Eure" },
  { code: "28", name: "28 - Eure-et-Loir" },
  { code: "29", name: "29 - Finistère" },
  { code: "30", name: "30 - Gard" },
  { code: "31", name: "31 - Haute-Garonne" },
  { code: "32", name: "32 - Gers" },
  { code: "33", name: "33 - Gironde" },
  { code: "34", name: "34 - Hérault" },
  { code: "35", name: "35 - Ille-et-Vilaine" },
  { code: "36", name: "36 - Indre" },
  { code: "37", name: "37 - Indre-et-Loire" },
  { code: "38", name: "38 - Isère" },
  { code: "39", name: "39 - Jura" },
  { code: "40", name: "40 - Landes" },
  { code: "41", name: "41 - Loir-et-Cher" },
  { code: "42", name: "42 - Loire" },
  { code: "43", name: "43 - Haute-Loire" },
  { code: "44", name: "44 - Loire-Atlantique" },
  { code: "45", name: "45 - Loiret" },
  { code: "46", name: "46 - Lot" },
  { code: "47", name: "47 - Lot-et-Garonne" },
  { code: "48", name: "48 - Lozère" },
  { code: "49", name: "49 - Maine-et-Loire" },
  { code: "50", name: "50 - Manche" },
  { code: "51", name: "51 - Marne" },
  { code: "52", name: "52 - Haute-Marne" },
  { code: "53", name: "53 - Mayenne" },
  { code: "54", name: "54 - Meurthe-et-Moselle" },
  { code: "55", name: "55 - Meuse" },
  { code: "56", name: "56 - Morbihan" },
  { code: "57", name: "57 - Moselle" },
  { code: "58", name: "58 - Nièvre" },
  { code: "59", name: "59 - Nord" },
  { code: "60", name: "60 - Oise" },
  { code: "61", name: "61 - Orne" },
  { code: "62", name: "62 - Pas-de-Calais" },
  { code: "63", name: "63 - Puy-de-Dôme" },
  { code: "64", name: "64 - Pyrénées-Atlantiques" },
  { code: "65", name: "65 - Hautes-Pyrénées" },
  { code: "66", name: "66 - Pyrénées-Orientales" },
  { code: "67", name: "67 - Bas-Rhin" },
  { code: "68", name: "68 - Haut-Rhin" },
  { code: "69", name: "69 - Rhône" },
  { code: "70", name: "70 - Haute-Saône" },
  { code: "71", name: "71 - Saône-et-Loire" },
  { code: "72", name: "72 - Sarthe" },
  { code: "73", name: "73 - Savoie" },
  { code: "74", name: "74 - Haute-Savoie" },
  { code: "75", name: "75 - Paris" },
  { code: "76", name: "76 - Seine-Maritime" },
  { code: "77", name: "77 - Seine-et-Marne" },
  { code: "78", name: "78 - Yvelines" },
  { code: "79", name: "79 - Deux-Sèvres" },
  { code: "80", name: "80 - Somme" },
  { code: "81", name: "81 - Tarn" },
  { code: "82", name: "82 - Tarn-et-Garonne" },
  { code: "83", name: "83 - Var" },
  { code: "84", name: "84 - Vaucluse" },
  { code: "85", name: "85 - Vendée" },
  { code: "86", name: "86 - Vienne" },
  { code: "87", name: "87 - Haute-Vienne" },
  { code: "88", name: "88 - Vosges" },
  { code: "89", name: "89 - Yonne" },
  { code: "90", name: "90 - Territoire de Belfort" },
  { code: "91", name: "91 - Essonne" },
  { code: "92", name: "92 - Hauts-de-Seine" },
  { code: "93", name: "93 - Seine-Saint-Denis" },
  { code: "94", name: "94 - Val-de-Marne" },
  { code: "95", name: "95 - Val-d'Oise" }
];

export default function FiltersModal({ isOpen, onClose, filters, onApply }) {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDepartments, setShowDepartments] = useState(false);

  const handleApply = () => {
    onApply(localFilters);
  };

  const handleReset = () => {
    const defaultFilters = {
      min_age: 18,
      max_age: 65,
      max_distance: 50,
      gender: "",
      department: ""
    };
    setLocalFilters(defaultFilters);
  };

  if (!isOpen) return null;

  const selectedDept = DEPARTMENTS.find(d => d.code === localFilters.department);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-end justify-center"
          data-testid="filters-modal"
        >
          {/* Backdrop */}
          <motion.div 
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={onClose}
          />
          
          {/* Content */}
          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="relative z-10 w-full max-w-lg bg-card rounded-t-3xl p-6 pb-10 max-h-[85vh] overflow-y-auto"
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <SlidersHorizontal className="w-5 h-5 text-primary" />
                <h2 className="font-heading text-xl font-semibold text-white">{tx("Filtres")}</h2>
              </div>
              <button
                onClick={onClose}
                className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20"
                data-testid="close-filters"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-6">
              {/* Age Range */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label className="text-white">{tx("Tranche d'âge")}</Label>
                  <span className="text-sm text-primary font-medium">
                    {localFilters.min_age} - {localFilters.max_age} ans
                  </span>
                </div>
                <div className="space-y-4">
                  <div>
                    <span className="text-xs text-muted-foreground">{tx("Âge minimum:")} {localFilters.min_age}</span>
                    <Slider
                      value={[localFilters.min_age]}
                      onValueChange={([value]) => setLocalFilters(prev => ({ 
                        ...prev, 
                        min_age: Math.min(value, prev.max_age - 1) 
                      }))}
                      min={18}
                      max={65}
                      step={1}
                      className="mt-2"
                      data-testid="min-age-slider"
                    />
                  </div>
                  <div>
                    <span className="text-xs text-muted-foreground">{tx("Âge maximum:")} {localFilters.max_age}</span>
                    <Slider
                      value={[localFilters.max_age]}
                      onValueChange={([value]) => setLocalFilters(prev => ({ 
                        ...prev, 
                        max_age: Math.max(value, prev.min_age + 1) 
                      }))}
                      min={18}
                      max={65}
                      step={1}
                      className="mt-2"
                      data-testid="max-age-slider"
                    />
                  </div>
                </div>
              </div>

              {/* Distance */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label className="text-white">{tx("Distance maximum")}</Label>
                  <span className="text-sm text-primary font-medium">
                    {localFilters.max_distance} km
                  </span>
                </div>
                <Slider
                  value={[localFilters.max_distance]}
                  onValueChange={([value]) => setLocalFilters(prev => ({ ...prev, max_distance: value }))}
                  min={1}
                  max={200}
                  step={1}
                  data-testid="distance-slider"
                />
              </div>

              {/* Department Filter */}
              <div className="space-y-3">
                <Label className="text-white flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  {tx("Département")}
                </Label>
                <button
                  onClick={() => setShowDepartments(!showDepartments)}
                  className="w-full py-3 px-4 rounded-xl bg-muted/50 text-left text-white border border-transparent hover:border-primary/50 transition-all"
                  data-testid="department-select"
                >
                  {selectedDept?.name || tx("Tous les départements")}
                </button>
                
                {showDepartments && (
                  <div className="max-h-48 overflow-y-auto bg-muted/50 rounded-xl border border-white/10">
                    {DEPARTMENTS.map((dept) => (
                      <button
                        key={dept.code}
                        onClick={() => {
                          setLocalFilters(prev => ({ ...prev, department: dept.code }));
                          setShowDepartments(false);
                        }}
                        className={`w-full py-2 px-4 text-left transition-all ${
                          localFilters.department === dept.code 
                            ? "bg-primary text-white" 
                            : "text-muted-foreground hover:bg-white/5 hover:text-white"
                        }`}
                      >
                        {tx(dept.name)}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Gender Filter */}
              <div className="space-y-3">
                <Label className="text-white">{tx("Je recherche")}</Label>
                <div className="flex gap-2">
                  <button
                    onClick={() => setLocalFilters(prev => ({ ...prev, gender: "" }))}
                    className={`flex-1 py-3 rounded-xl font-medium transition-all ${
                      localFilters.gender === "" 
                        ? "bg-primary text-white" 
                        : "bg-muted/50 text-muted-foreground hover:bg-muted"
                    }`}
                    data-testid="gender-all"
                  >
                    {tx("Tous")}
                  </button>
                  <button
                    onClick={() => setLocalFilters(prev => ({ ...prev, gender: "Femme" }))}
                    className={`flex-1 py-3 rounded-xl font-medium transition-all ${
                      localFilters.gender === "Femme" 
                        ? "bg-primary text-white" 
                        : "bg-muted/50 text-muted-foreground hover:bg-muted"
                    }`}
                    data-testid="gender-femme"
                  >
                    {tx("Femmes")}
                  </button>
                  <button
                    onClick={() => setLocalFilters(prev => ({ ...prev, gender: "Homme" }))}
                    className={`flex-1 py-3 rounded-xl font-medium transition-all ${
                      localFilters.gender === "Homme" 
                        ? "bg-primary text-white" 
                        : "bg-muted/50 text-muted-foreground hover:bg-muted"
                    }`}
                    data-testid="gender-homme"
                  >
                    {tx("Hommes")}
                  </button>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3 mt-8">
              <Button
                variant="outline"
                onClick={handleReset}
                className="flex-1 h-12 rounded-xl border-white/20 text-white"
                data-testid="reset-filters-btn"
              >
                {tx("Réinitialiser")}
              </Button>
              <Button
                onClick={handleApply}
                className="flex-1 h-12 rounded-xl bg-primary text-white font-bold"
                data-testid="apply-filters-btn"
              >
                {tx("Appliquer")}
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
